const decedentInfoOverlayStyles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionHeader: {
    px: 4,
    py: 3,
    backgroundColor: '#FAF9F7',
  },
  sectionBody: { px: 4, gap: 2 },
};

export default decedentInfoOverlayStyles;
